import React from "react";
import { Quote, Star } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import type { Testimonial } from "../data/testimonials";
interface TestimonialCardProps {
  testimonial: Testimonial;
}
const stars = [1, 2, 3, 4, 5];
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  const shouldReduceMotion = Boolean(useReducedMotion());
  return <motion.article initial={shouldReduceMotion ? false : {
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative overflow-hidden rounded-[24px] border border-[#313743] bg-[linear-gradient(135deg,#151B24_0%,#141922_55%,#11161E_100%)] p-5 shadow-[0_24px_70px_rgba(0,0,0,0.28)] transition-[transform,border-color,box-shadow] duration-300 ease-out motion-safe:hover:-translate-y-[3px] hover:border-[#F2B84B]/35 hover:shadow-[0_28px_76px_rgba(0,0,0,0.34),0_0_30px_rgba(242,184,75,0.055)] sm:p-8 lg:p-10" data-id="element-206" data-mp="2u7axjnne0s4w">
      <div className="flex items-start justify-between gap-5" data-id="element-207" data-mp="huxj1xvr7avx">
        <div className="flex items-center gap-1.5" aria-label="5 de 5 estrellas" data-id="element-208" data-mp="d12y6r4ewpv9">
          {stars.map(star => <Star key={star} aria-hidden="true" className="h-4 w-4 fill-[#F2B84B] stroke-[#F2B84B] sm:h-[18px] sm:w-[18px]" data-id="element-209" data-mp="83t24smipfyg" />)}
        </div>
        <Quote aria-hidden="true" className="h-9 w-9 shrink-0 fill-[#F2B84B]/10 stroke-[#E9D9B8]/70 sm:h-11 sm:w-11" data-id="element-210" data-mp="323or6btoq77" />
      </div>

      <blockquote className="mt-7 max-w-[780px] text-[17px] italic leading-8 tracking-[-0.01em] text-[#F3EEE8] sm:mt-8 sm:text-xl sm:leading-9 lg:text-[22px] lg:leading-10" data-id="element-211" data-mp="vs2l7mscjplw">
        {testimonial.quote}
      </blockquote>

      <div aria-hidden="true" className="my-7 h-px w-full bg-[#313743]/90 sm:my-8" data-id="element-212" data-mp="ltegfppdh705" />

      <div className="flex items-center gap-4" data-id="element-213" data-mp="3bk050wx3z966">
        <img src={testimonial.avatarUrl} alt={`Retrato de ${testimonial.name}`} className="h-14 w-14 rounded-full border border-[#F2B84B]/35 object-cover shadow-[0_6px_20px_rgba(0,0,0,0.35)] sm:h-16 sm:w-16" loading="lazy" decoding="async" data-id="element-214" data-mp="3bhngg0wui0k5" />
        <h3 className="text-base font-bold tracking-[-0.01em] text-[#F3EEE8] sm:text-lg" data-id="element-215" data-mp="22nbf78978oou">
          {testimonial.name}
        </h3>
      </div>
    </motion.article>;
}